import LoseBase from '../components/base/lose-base';
import React from 'react';

const TourneysComponentsFormRulesPartLose = () => {
  return <LoseBase sportType="general" />;
};

export default TourneysComponentsFormRulesPartLose;
